import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import { translate } from "../../../../../components/translate/translate.jsx";

const ReportContent = ({data, tableColumns}) => {
    const columns = [
        {id: "login", label: "Agente", className: "w-[10%]", renderCell: element => extractKey(element, "login")},
        {id: "date_time", label: "D/H exportação", className: "w-[10%]", renderCell: element => extractKey(element, "date_time")},
        {id: "type", label: "Tipo", className: "w-[7%]", renderCell: element => translate(extractKey(element.payload, "exportType"))},
        {id: "watermark", label: "Marca d'água", className: "w-[10%]", renderCell: element => "imageWithWaterMark" in element.payload && element.payload.imageWithWaterMark ? "Sim" : "Não"},
        {id: "plate", label: "Placa", className: "w-[7%]", renderCell: element => extractKey(element.payload, "plate")},
        {id: "capture_time", label: "D/H passagem", className: "w-[12%]", renderCell: element => element.payload.captureTime ? new Date(element.payload.captureTime).toLocaleString("pt-BR") : ""},
        {id: "camera", label: "Câmera", className: "w-[33%]", renderCell: element => element.payload.capturePlace + " (" + element.payload.lane + " - " + element.payload.direction + ")"},
        {id: "city", label: "Município", className: "w-[11%]", renderCell: element => extractKey(element.payload, "city")},
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Exportação de imagens`, "image-export-data");
    }, [data, tableColumns]);

    function extractKey(node = {}, key = '') {
        if (!node || !key || typeof node !== 'object' || typeof key !== 'string') return '';
        if (typeof node[key] !== 'string' || !node[key] || !(key in node)) return '';
        if (node[key].trim() === 'null') return '';
        return node[key].trim();
    }

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : <table id="image-export-data" className="table report-table" sheet-name="Exportação de imagens">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                    {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.map((element, index) => <tr key={index} className="table-break-word">{visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}</tr>)}
                </tbody>
            </table>}

            <div id="chart-tables"/>

        </>
    );
};

export default ReportContent;